var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g2, _path44, _path45, _path46, _g3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g4, _path54, _path55, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExpertCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_559_2073)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#679CF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1946 27.4999C26.0453 27.1385 25.6289 26.9655 25.2645 27.1136C24.9 27.2616 24.7256 27.6746 24.8749 28.036C25.0242 28.3974 25.4406 28.5704 25.805 28.4223C26.1694 28.2743 26.3438 27.8613 26.1946 27.4999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6887 28.0695C24.7005 27.6792 24.3911 27.3533 23.9976 27.3416C23.6041 27.3298 23.2754 27.6367 23.2636 28.0269C23.2517 28.4172 23.5611 28.7431 23.9547 28.7549C24.3482 28.7666 24.6768 28.4598 24.6887 28.0695Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.058 27.9777C23.2289 27.6259 23.0799 27.2032 22.7251 27.0337C22.3703 26.8642 21.9441 27.012 21.7732 27.3638C21.6023 27.7157 21.7513 28.1383 22.1061 28.3079C22.4609 28.4774 22.887 28.3296 23.058 27.9777Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6245 27.2512C21.9248 26.9988 21.962 26.5527 21.7075 26.2548C21.453 25.9569 21.0032 25.92 20.7028 26.1724C20.4024 26.4248 20.3652 26.8709 20.6197 27.1688C20.8742 27.4667 21.3241 27.5036 21.6245 27.2512Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6193 26.0127C20.9973 25.9032 21.2143 25.5106 21.104 25.1357C20.9936 24.7608 20.5977 24.5456 20.2197 24.6551C19.8417 24.7645 19.6247 25.1571 19.735 25.532C19.8454 25.9069 20.2413 26.1221 20.6193 26.0127Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2084 24.43C20.5986 24.4825 20.9578 24.2113 21.0107 23.8244C21.0636 23.4375 20.7903 23.0812 20.4001 23.0288C20.0099 22.9763 19.6508 23.2474 19.5978 23.6343C19.5449 24.0213 19.8183 24.3775 20.2084 24.43Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4391 22.8768C20.774 23.0821 21.2134 22.9793 21.4205 22.6471C21.6276 22.3149 21.5239 21.8791 21.189 21.6738C20.854 21.4684 20.4146 21.5712 20.2076 21.9034C20.0005 22.2356 20.1041 22.6714 20.4391 22.8768Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3226 21.525C21.5443 21.8477 21.9878 21.931 22.3131 21.7111C22.6385 21.4912 22.7225 21.0513 22.5008 20.7287C22.2791 20.406 21.8356 20.3227 21.5102 20.5426C21.1849 20.7625 21.1009 21.2023 21.3226 21.525Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7024 20.667C22.7726 21.0512 23.1436 21.3062 23.531 21.2366C23.9185 21.1669 24.1756 20.799 24.1054 20.4148C24.0351 20.0306 23.6642 19.7756 23.2767 19.8452C22.8893 19.9148 22.6321 20.2828 22.7024 20.667Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2913 20.4146C24.1979 20.794 24.4322 21.1766 24.8148 21.2693C25.1973 21.362 25.5832 21.1295 25.6766 20.7502C25.77 20.3708 25.5356 19.9881 25.1531 19.8955C24.7706 19.8028 24.3848 20.0353 24.2913 20.4146Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8634 20.8514C25.6225 21.1603 25.6796 21.6044 25.9911 21.8433C26.3025 22.0823 26.7503 22.0256 26.9912 21.7167C27.2321 21.4078 27.175 20.9637 26.8636 20.7248C26.5521 20.4858 26.1043 20.5425 25.8634 20.8514Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1365 21.8352C26.7897 22.0202 26.6598 22.4489 26.8463 22.7928C27.0328 23.1367 27.4651 23.2656 27.8119 23.0806C28.1587 22.8956 28.2886 22.4669 28.1021 22.123C27.9156 21.7791 27.4832 21.6502 27.1365 21.8352Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8429 23.2934C27.4503 23.3225 27.1558 23.6617 27.1852 24.0511C27.2145 24.4405 27.5566 24.7325 27.9492 24.7034C28.3418 24.6743 28.6363 24.3351 28.607 23.9457C28.5776 23.5563 28.2355 23.2643 27.8429 23.2934Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9414 24.862C27.5707 24.7302 27.1624 24.9214 27.0295 25.289C26.8966 25.6567 27.0894 26.0615 27.4601 26.1934C27.8308 26.3252 28.239 26.134 28.3719 25.7664C28.5049 25.3987 28.3121 24.9939 27.9414 24.862Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3556 26.3542C27.0711 26.0843 26.6198 26.0942 26.3477 26.3764C26.0755 26.6586 26.0856 27.1061 26.3701 27.376C26.6546 27.6459 27.1059 27.636 27.3781 27.3538C27.6502 27.0716 27.6401 26.6241 27.3556 26.3542Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7258 28.9389C25.5766 28.5774 25.1601 28.4045 24.7957 28.5525C24.4313 28.7005 24.2569 29.1135 24.4061 29.475C24.5554 29.8364 24.9719 30.0093 25.3363 29.8613C25.7007 29.7133 25.8751 29.3003 25.7258 28.9389Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5969 30.0087C21.4477 29.6473 21.0312 29.4743 20.6668 29.6223C20.3024 29.7704 20.128 30.1834 20.2772 30.5448C20.4265 30.9062 20.8429 31.0792 21.2074 30.9311C21.5718 30.7831 21.7462 30.3701 21.5969 30.0087Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2453 28.4818C16.0961 28.1204 15.6797 27.9475 15.3152 28.0955C14.9508 28.2435 14.7764 28.6565 14.9257 29.0179C15.075 29.3793 15.4914 29.5523 15.8558 29.4043C16.2202 29.2562 16.3946 28.8432 16.2453 28.4818Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9387 19.8632C33.7895 19.5018 33.373 19.3288 33.0086 19.4768C32.6442 19.6249 32.4698 20.0378 32.619 20.3993C32.7683 20.7607 33.1847 20.9336 33.5492 20.7856C33.9135 20.6376 34.088 20.2246 33.9387 19.8632Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5813 15.3559C19.432 14.9945 19.0156 14.8215 18.6512 14.9695C18.2868 15.1175 18.1123 15.5305 18.2616 15.8919C18.4109 16.2533 18.8273 16.4263 19.1917 16.2783C19.5561 16.1302 19.7305 15.7173 19.5813 15.3559Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5403 28.9276C23.391 28.5662 22.9746 28.3933 22.6102 28.5413C22.2457 28.6893 22.0713 29.1023 22.2206 29.4637C22.3699 29.8251 22.7863 29.9981 23.1507 29.8501C23.5151 29.702 23.6895 29.2891 23.5403 28.9276Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2825 24.3031C19.1332 23.9417 18.7168 23.7687 18.3523 23.9168C17.9879 24.0648 17.8135 24.4778 17.9628 24.8392C18.1121 25.2006 18.5285 25.3736 18.8929 25.2256C19.2573 25.0775 19.4317 24.6645 19.2825 24.3031Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1692 26.3344C20.0199 25.973 19.6035 25.8 19.2391 25.948C18.8747 26.0961 18.7002 26.5091 18.8495 26.8705C18.9988 27.2319 19.4152 27.4049 19.7796 27.2568C20.144 27.1088 20.3184 26.6958 20.1692 26.3344Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7024 32.7269C23.5531 32.3655 23.1367 32.1926 22.7723 32.3406C22.4078 32.4886 22.2334 32.9016 22.3827 33.263C22.532 33.6244 22.9484 33.7974 23.3128 33.6494C23.6772 33.5013 23.8516 33.0884 23.7024 32.7269Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3704 27.9242C21.2211 27.5628 20.8047 27.3898 20.4402 27.5379C20.0758 27.6859 19.9014 28.0989 20.0507 28.4603C20.1999 28.8217 20.6164 28.9947 20.9808 28.8466C21.3452 28.6986 21.5196 28.2856 21.3704 27.9242Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4524 29.1444C19.3031 28.783 18.8867 28.6101 18.5223 28.7581C18.1579 28.9061 17.9834 29.3191 18.1327 29.6805C18.282 30.0419 18.6984 30.2149 19.0628 30.0669C19.4272 29.9188 19.6016 29.5058 19.4524 29.1444Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5637 22.7445C19.4144 22.3831 18.998 22.2102 18.6336 22.3582C18.2692 22.5062 18.0948 22.9192 18.244 23.2806C18.3933 23.642 18.8097 23.815 19.1742 23.667C19.5385 23.5189 19.713 23.1059 19.5637 22.7445Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5871 18.4491C19.4379 18.0877 19.0215 17.9147 18.657 18.0628C18.2926 18.2108 18.1182 18.6238 18.2675 18.9852C18.4168 19.3466 18.8332 19.5196 19.1976 19.3715C19.562 19.2235 19.7364 18.8105 19.5871 18.4491Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7258 19.018C16.5766 18.6565 16.1601 18.4836 15.7957 18.6316C15.4313 18.7796 15.2569 19.1926 15.4062 19.5541C15.5554 19.9155 15.9718 20.0884 16.3362 19.9404C16.7007 19.7924 16.8751 19.3794 16.7258 19.018Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9133 20.6098C20.7641 20.2484 20.3476 20.0754 19.9832 20.2234C19.6188 20.3714 19.4444 20.7845 19.5936 21.1459C19.7429 21.5073 20.1593 21.6802 20.5238 21.5322C20.8882 21.3841 21.0626 20.9712 20.9133 20.6098Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5344 30.7328C24.3852 30.3714 23.9687 30.1984 23.6043 30.3465C23.2399 30.4945 23.0654 30.9075 23.2147 31.2689C23.364 31.6303 23.7804 31.8033 24.1448 31.6552C24.5093 31.5072 24.6837 31.0942 24.5344 30.7328Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8938 19.2846C22.7445 18.9231 22.3281 18.7502 21.9637 18.8982C21.5992 19.0463 21.4248 19.4592 21.5741 19.8207C21.7234 20.1821 22.1398 20.355 22.5042 20.207C22.8686 20.059 23.043 19.646 22.8938 19.2846Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2473 18.1044C28.0981 17.743 27.6816 17.57 27.3172 17.7181C26.9528 17.8661 26.7784 18.2791 26.9276 18.6405C27.0769 19.0019 27.4933 19.1749 27.8577 19.0268C28.2222 18.8788 28.3966 18.4658 28.2473 18.1044Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2004 17.1864C25.0512 16.825 24.6347 16.652 24.2703 16.8001C23.9059 16.9481 23.7315 17.3611 23.8808 17.7225C24.03 18.0839 24.4465 18.2569 24.8109 18.1089C25.1753 17.9608 25.3497 17.5478 25.2004 17.1864Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2981 15.6644C27.1488 15.303 26.7324 15.1301 26.368 15.2781C26.0036 15.4261 25.8292 15.8391 25.9784 16.2005C26.1277 16.5619 26.5441 16.7349 26.9085 16.5869C27.273 16.4388 27.4473 16.0258 27.2981 15.6644Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8996 18.9364C24.7504 18.575 24.334 18.402 23.9695 18.5501C23.6051 18.6981 23.4307 19.1111 23.58 19.4725C23.7293 19.8339 24.1457 20.0069 24.5101 19.8589C24.8745 19.7108 25.0489 19.2978 24.8996 18.9364Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0305 19.4374C26.8813 19.076 26.4648 18.903 26.1004 19.0511C25.736 19.1991 25.5616 19.6121 25.7108 19.9735C25.8601 20.3349 26.2765 20.5079 26.641 20.3598C27.0054 20.2118 27.1798 19.7988 27.0305 19.4374Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8586 20.8002C28.7094 20.4388 28.2929 20.2658 27.9285 20.4138C27.5641 20.5619 27.3897 20.9749 27.539 21.3363C27.6882 21.6977 28.1046 21.8707 28.4691 21.7226C28.8335 21.5746 29.0079 21.1616 28.8586 20.8002Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0754 26.6952C28.9262 26.3338 28.5097 26.1608 28.1453 26.3089C27.7809 26.4569 27.6065 26.8699 27.7558 27.2313C27.905 27.5927 28.3214 27.7657 28.6859 27.6176C29.0503 27.4696 29.2247 27.0566 29.0754 26.6952Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1125 28.077C27.9633 27.7156 27.5469 27.5427 27.1824 27.6907C26.818 27.8387 26.6436 28.2517 26.7929 28.6131C26.9421 28.9745 27.3585 29.1475 27.723 28.9995C28.0874 28.8514 28.2618 28.4385 28.1125 28.077Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6262 22.6395C29.477 22.2781 29.0605 22.1052 28.6961 22.2532C28.3317 22.4012 28.1573 22.8142 28.3065 23.1756C28.4558 23.5371 28.8722 23.71 29.2367 23.562C29.6011 23.4139 29.7755 23.001 29.6262 22.6395Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7688 24.7045C29.6195 24.3431 29.2031 24.1701 28.8387 24.3181C28.4742 24.4662 28.2998 24.8792 28.4491 25.2406C28.5984 25.602 29.0148 25.775 29.3792 25.6269C29.7436 25.4789 29.918 25.0659 29.7688 24.7045Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_559_2073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 15,
    width: 3,
    height: 3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1348 17.6416L31.4821 17.1512L31.0015 15.8305L29.6541 16.3209L30.1348 17.6416Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_559_2073)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2317 16.4649C31.0843 16.1058 30.6677 15.9362 30.3012 16.086C29.9347 16.2358 29.7571 16.6482 29.9045 17.0073C30.0519 17.3663 30.4685 17.5359 30.835 17.3861C31.2015 17.2363 31.3791 16.8239 31.2317 16.4649Z",
    fill: "white"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7102 25.5761C17.5609 25.2147 17.1445 25.0417 16.7801 25.1897C16.4157 25.3378 16.2413 25.7508 16.3905 26.1122C16.5398 26.4736 16.9562 26.6465 17.3206 26.4985C17.685 26.3505 17.8595 25.9375 17.7102 25.5761Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7629 22.3593C17.6137 21.9979 17.1972 21.8249 16.8328 21.9729C16.4684 22.1209 16.294 22.5339 16.4433 22.8954C16.5925 23.2568 17.009 23.4297 17.3734 23.2817C17.7378 23.1337 17.9122 22.7207 17.7629 22.3593Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_559_2073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 23,
    width: 3,
    height: 2
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8574 24.916L16.2307 24.4162L15.7443 23.0799L14.3711 23.5798L14.8574 24.916Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_559_2073)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9773 23.7217C15.8281 23.3585 15.4043 23.1878 15.0307 23.3403C14.6571 23.4929 14.4752 23.911 14.6244 24.2742C14.7737 24.6374 15.1975 24.8082 15.5711 24.6556C15.9447 24.5031 16.1266 24.085 15.9773 23.7217Z",
    fill: "white"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8137 19.1532C30.6644 18.7918 30.248 18.6188 29.8836 18.7669C29.5192 18.9149 29.3448 19.3279 29.494 19.6893C29.6433 20.0507 30.0597 20.2237 30.4242 20.0757C30.7886 19.9276 30.963 19.5146 30.8137 19.1532Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9563 25.765C32.807 25.4036 32.3906 25.2307 32.0262 25.3787C31.6617 25.5267 31.4873 25.9397 31.6366 26.3011C31.7859 26.6625 32.2023 26.8355 32.5667 26.6875C32.9311 26.5394 33.1055 26.1264 32.9563 25.765Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2746 22.0907C31.1254 21.7293 30.709 21.5563 30.3445 21.7044C29.9801 21.8524 29.8057 22.2654 29.955 22.6268C30.1043 22.9882 30.5207 23.1612 30.8851 23.0132C31.2495 22.8651 31.4239 22.4521 31.2746 22.0907Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1672 26.0643C31.018 25.703 30.6015 25.53 30.2371 25.678C29.8727 25.826 29.6983 26.239 29.8476 26.6004C29.9968 26.9618 30.4133 27.1348 30.7777 26.9868C31.1421 26.8387 31.3165 26.4257 31.1672 26.0643Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0227 16.7919C22.8734 16.4305 22.457 16.2575 22.0926 16.4055C21.7281 16.5536 21.5538 16.9666 21.703 17.328C21.8523 17.6894 22.2687 17.8624 22.6331 17.7143C22.9975 17.5663 23.1719 17.1533 23.0227 16.7919Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9973 29.4516C28.848 29.0902 28.4316 28.9172 28.0672 29.0652C27.7028 29.2132 27.5284 29.6262 27.6776 29.9877C27.8269 30.349 28.2433 30.522 28.6077 30.374C28.9722 30.2259 29.1466 29.813 28.9973 29.4516Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_559_2073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 31,
    width: 3,
    height: 3
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7109 33.2739L29.0583 32.7835L28.572 31.4473L27.2246 31.9377L27.7109 33.2739Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_559_2073)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8049 32.0891C28.656 31.7258 28.2382 31.5528 27.8717 31.7028C27.5053 31.8527 27.329 32.2688 27.478 32.6321C27.6269 32.9954 28.0447 33.1684 28.4112 33.0185C28.7776 32.8685 28.9539 32.4524 28.8049 32.0891Z",
    fill: "white"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0989 28.9896C31.9496 28.6282 31.5332 28.4553 31.1688 28.6033C30.8043 28.7513 30.6299 29.1643 30.7792 29.5257C30.9284 29.8871 31.3449 30.0601 31.7093 29.9121C32.0737 29.764 32.2481 29.351 32.0989 28.9896Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5793 30.2304C26.4301 29.8689 26.0136 29.696 25.6492 29.844C25.2848 29.9921 25.1104 30.4051 25.2597 30.7665C25.4089 31.1279 25.8254 31.3009 26.1898 31.1528C26.5542 31.0048 26.7286 30.5918 26.5793 30.2304Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_559_2073",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_559_2073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_559_2073",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpertCard);
export default __webpack_public_path__ + "static/media/icon-expert-card.afa3da774ddd8528a616536955efe317.svg";
export { ForwardRef as ReactComponent };